enum ContactBankCardType {
    BPA = "BPA",
    METROPOLITANO = "METROPOLITANO",
    BANDEC = "BANDEC",
    AIS = "AIS"
}

export default ContactBankCardType;